var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._g(_vm._b({ref:"bInput",staticClass:"b-input"},'el-input',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"prefix"},[_vm._t("prefix")],2),_c('template',{slot:"suffix"},[_vm._t("suffix")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }